export const SET_FEATURED_PRODUCTS = 'SET_FEATURED_PRODUCTS'

export function setFeaturedProducts (featuredProducts) {
  return {
    type: SET_FEATURED_PRODUCTS,
    featuredProducts
  }
}
